import PropTypes from 'prop-types';
import { BsCreditCard } from 'react-icons/bs';

import { PlanPrice } from '../PlanPrice/PlanPrice';

export const CurrentPlanHeader = ({ planName, planPriceCents, planDescription, badge }) => (
	<div className="border-b border-bgBase-500 bg-bgBase-300 px-5 py-4">
		<div className="flex items-center justify-between gap-3">
			<p className="flex items-center gap-2 text-xs-head text-bgBase-800">
				<BsCreditCard className="h-4 w-4 text-primary-500" />
				Ihr Abonnement
			</p>
			{badge}
		</div>

		<div className="mt-2 flex flex-wrap items-end justify-between gap-x-6 gap-y-2">
			<div className="min-w-0">
				<h2 className="text-lg-bold text-text">{planName}</h2>
				{planDescription && <p className="mt-0.5 text-sm text-bgBase-800">{planDescription}</p>}
			</div>
			<PlanPrice amountCents={planPriceCents} isHighlighted />
		</div>
	</div>
);

CurrentPlanHeader.propTypes = {
	planName: PropTypes.string.isRequired,
	planPriceCents: PropTypes.number.isRequired,
	planDescription: PropTypes.string,
	badge: PropTypes.node,
};
